﻿import { createApp } from 'vue/dist/vue.esm-bundler';
const axios = require('axios');
import eventBlock from './Vue/eventBlock.vue';

document.addEventListener('DOMContentLoaded', () => {
    // Only build the Vue instance if the targeted element is present.
    if (document.getElementById('mainSearch')) {
        const searchApp = createApp({
            components: {
                eventBlock
            },
            data() {
                return {
                    dataApi: '',
                    dataSort: [],
                    dataIds: '',
                    idArray: [],
                    data: null,
                    items: [],
                    courseTitle: '',
                    eventsTitle: '',
                    lessonsTitle: '',
                    readmore: '',
                    loading: true,
                }
            },
            computed: {
                filterItems() {
                    return [{ Key: 'id.keyword', Values: this.idArray, Operator: 'in' }]
                },
                queryModel() {
                    return {
                        Offset: 0,
                        OrderItems: this.dataSort,
                        FilterItems: this.filterItems,
                        Text: this.searchText
                    }
                }
            },
            methods: {
                fetchData() {
                    axios
                        .post(this.dataApi, this.queryModel)
                        .then(response => {
                            if (response.status === 200) {
                                this.data = response.data;
                                this.items = this.data.items;
                                this.loading = false;
                            }
                        })
                        .catch(error => console.log(error))
                },
                reverse(array) {
                    return [...array].reverse();
                },
                toGenreString(genreArray) {
                    if (!genreArray || !genreArray.length) return '';
                    return genreArray.map(genre => genre.name).join(' | ');
                },
                buttonStatusClass(status) {
                    //NotSet = 0,
                    //Available = 1,
                    //SoldOut = 2,
                    //Cancelled = 3,
                    //LastTickets = 4
                    switch (status) {
                        case "0":
                            return "";
                            break;
                        case "1":
                            return "";
                            break;
                        case "2":
                            return "is-theatre";
                            break;
                        case "3":
                            return "disabled";
                            break;
                        case "4":
                            return "is-theatre";
                            break;
                        default:
                            return "";
                    }
                },
                isEvent(item) {
                    if (!item || !item.agendaType) return false;
                    return item.agendaType == 'Event';
                },
                isCourse(item) {
                    if (!item || !item.agendaType) return false;
                    return item.agendaType == 'Course';
                },
                toMediaQuery(mediaString) {
                    if (!mediaString) return '';
                    return mediaString.split('"')[1];
                },
                toLowercase(string) {
                    return string.toLowerCase();
                },
                toShortDateStr(dateString) {
                    return new Date(dateString).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' }).replace('.', '');
                },
                toDayStr(dateString) {
                    return new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short' });
                },
                showTitle(index, item) {
                    let returnVal = null;
                    if (index === 0) {
                        returnVal = this.getTitleByType(item.agendaType);
                    } else {
                        let prevEvent = this.items[index - 1];
                        if (prevEvent) {
                            if (item.agendaType !== prevEvent.agendaType) {
                                returnVal = this.getTitleByType(item.agendaType);
                            }
                        }
                    }
                    return returnVal;
                },
                getTitleByType(type) {
                    switch (type) {
                        case 'Course':
                            return this.courseTitle
                            break;
                        case 'Lesson':
                            return this.lessonsTitle
                            break;
                        case 'Event':
                            return this.eventsTitle
                            break;
                        default:
                            return ''
                    }
                },
                stripHtml(htmlString) {
                    return htmlString.replace(/(<([^>]+)>)/gi, "");
                },
                truncateHtml(htmlString) {
                    let strippedString = this.stripHtml(htmlString);
                    if (strippedString.length < 160) return strippedString
                    return strippedString.replace(/^(.{160}[^\s]*).*/, "$1").trim() + '&hellip;'
                }
            },
            mounted() {
                // Set data props according to data attributes in HTML template.
                if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
                if (this.$el.dataset.ids) this.dataIds = this.$el.dataset.ids;
                this.idArray = this.dataIds.split(',');
                if (this.$el.dataset.sort) this.dataSort = JSON.parse(this.$el.dataset.sort);
                if (this.$el.dataset.coursetitle) this.courseTitle = this.$el.dataset.coursetitle;
                if (this.$el.dataset.eventstitle) this.eventsTitle = this.$el.dataset.eventstitle;
                if (this.$el.dataset.lessonstitle) this.lessonsTitle = this.$el.dataset.lessonstitle;
                if (this.$el.dataset.readmore) this.readmore = this.$el.dataset.readmore;
                this.fetchData();
            }
        });

        searchApp.mount('#mainSearch');
    }
});